<div
  fxLayout="column"
  fxLayoutAlign="space-between stretch"
  class="connect-bg connect-channel"
>
  <h2>Add Facebook Messenger</h2>
  <h3>Step 1. Create a Facebook Page</h3>
  <p>
    You need a Facebook Page where your users will message you. You can
    <a href="https://www.facebook.com/pages/create/" target="_blank"
      >create a Facebook Page here</a
    >
    or skip to Step 2 if you already have one.
  </p>
  <h3>Step 2. Connect your Facebook account with Hubtype</h3>
  @if (loginStatus?.status === 'connected' && !loadingUser) {
    <p fxLayout="row" fxFlexAlign="start center"> You're now logged in as: </p>
  }
  @if (loginStatus?.status === 'connected' && !loadingUser) {
    <p>
      <strong class="fb-name"
        >{{ curUser?.firstName }} {{ curUser?.lastName }}</strong
      >
      <span
        class="fb-logout"
        (click)="logoutFb()"
        fxFlex="none"
        fxLayout="row"
        fxLayoutAlign="center center"
      >
        <span>Logout</span>
        <mat-icon>close</mat-icon>
      </span>
    </p>
  }
  @if (loadingUser) {
    <div fxFlexAlign="center" @loadData>
      <mat-spinner [diameter]="32" [strokeWidth]="3.2"></mat-spinner>
    </div>
  }
  @if (!curUser && !loadingUser) {
    <button
      mat-raised-button
      fxFlex="none"
      type="submit"
      (click)="connectAccount()"
    >
      Connect Facebook
    </button>
  }

  <h3 [ngClass]="{ disabled: !curUser }">Step 3. Select a Page</h3>
  @if (feedback) {
    <p class="text-feedback"> There was a problem getting the Pages </p>
  }
  @if (facebookPages && !facebookPages?.length) {
    <p>
      You don't have any Facebook Page. Please create one and
      <span class="refresh-fb-pages" (click)="connectAccount()"
        >refresh<mat-icon>refresh</mat-icon></span
      >
    </p>
  }
  @if (facebookPages && facebookPages?.length) {
    <p> The messages you get to this page will be sent to Hubtype: </p>
  }
  @if (loadingPages) {
    <div fxFlexAlign="center" @loadData>
      <mat-spinner [diameter]="32" [strokeWidth]="3.2"></mat-spinner>
    </div>
  }
  @if (facebookPages && !loadingPages) {
    <div
      fxFlex
      fxLayout="row"
      fxLayoutAlign="center center"
      class="pages-select"
    >
      <mat-select
        fxFlex="none"
        [(ngModel)]="selectedFacebookPage"
        floatPlaceholder="never"
      >
        @for (page of facebookPages; track page) {
          <mat-option [value]="page">
            <img width="20" [src]="page.pic" /> <span>{{ page.name }}</span>
          </mat-option>
        }
      </mat-select>
      @if (facebookPages?.length) {
        <span
          class="refresh-fb-pages"
          mat-icon-button
          (click)="refreshPages()"
          fxFlex="none"
          fxLayout="row"
          fxLayoutAlign="center center"
        >
          <span>refresh</span>
          <mat-icon>refresh</mat-icon>
        </span>
      }
    </div>
  }
  <button
    mat-raised-button
    fxFlex="none"
    type="submit"
    [disabled]="!(facebookPages && selectedFacebookPage)"
    (click)="connectPage()"
  >
    Connect Page
  </button>
</div>
